import { render, staticRenderFns } from "./HeroStartup.vue?vue&type=template&id=2652802c&scoped=true&"
import script from "./HeroStartup.vue?vue&type=script&lang=js&"
export * from "./HeroStartup.vue?vue&type=script&lang=js&"
import style0 from "./HeroStartup.vue?vue&type=style&index=0&id=2652802c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2652802c",
  null
  
)

export default component.exports